var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

import EventRunnerDefault from "./EventRunnerDefault";

var EventRunnerNTimes = function (_super) {
  __extends(EventRunnerNTimes, _super);

  function EventRunnerNTimes(emitter, handler, total) {
    if (total === void 0) {
      total = 1;
    }

    var _this = _super.call(this, emitter, handler) || this;

    _this.total = total;
    _this.i = 0;

    if (_this.total < 1) {
      throw new Error("{total} can not be less than 1");
    }

    return _this;
  }

  EventRunnerNTimes.prototype.run = function (eventName) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    _super.prototype.run.apply(this, __spreadArrays([eventName], args));

    if (++this.i >= this.total) {
      this.emitter.off(eventName, this.handler);
    }
  };

  return EventRunnerNTimes;
}(EventRunnerDefault);

export default EventRunnerNTimes;